/**
 * Prowizja Booking dla planu (rate): z `integrations.booking.rates[planId]`,
 * gdy klucz istnieje; inaczej — opcjonalnie `percent` z integracji pokoju
 * (plan główny bez wpisu w rates); na końcu globalny `percent` cennika.
 */
export function getBookingCommissionPercentForPlan(
  booking:
    | {
        percent?: unknown
        rates?: Record<string, unknown>
      }
    | undefined,
  planBookingId: string | number | undefined | null,
  roomIntegration?: { percent?: unknown } | null,
): number {
  if (!booking) return 0
  const id =
    planBookingId !== undefined && planBookingId !== null
      ? String(planBookingId)
      : ''
  const rates = booking.rates
  if (
    rates &&
    typeof rates === 'object' &&
    id &&
    Object.prototype.hasOwnProperty.call(rates, id)
  ) {
    const v = rates[id]
    if (v === '' || v === undefined || v === null) return 0
    const n = Number(v)
    return Number.isFinite(n) ? n : 0
  }
  if (
    roomIntegration &&
    roomIntegration.percent !== undefined &&
    roomIntegration.percent !== null &&
    roomIntegration.percent !== ''
  ) {
    const ip = Number(roomIntegration.percent)
    if (Number.isFinite(ip)) return ip
  }
  const p = Number(booking.percent ?? 0)
  return Number.isFinite(p) ? p : 0
}
